import { Card, Input } from 'antd';
import { useSimulation } from '../../context/SimulationContext';
import { ACTION_TEXT_MAX_LENGTH } from '../../constants/simulation.constants';
import './ActionInput.scss';

function ActionInput() {
  const { actionText, isSubmitting, sessionStatus, dispatch } =
    useSimulation();

  return (
    <Card className="action-input" size="small">
      <Input.TextArea
        value={actionText}
        onChange={(e) =>
          dispatch({ type: 'SET_ACTION_TEXT', payload: e.target.value })
        }
        placeholder="Describe your next action or decision..."
        rows={4}
        maxLength={ACTION_TEXT_MAX_LENGTH}
        showCount
        disabled={isSubmitting || sessionStatus !== 'active'}
      />
    </Card>
  );
}

export default ActionInput;
